import { aiApi } from './ai'

export const {
  useGetEmployeePerformanceQuery,
  useGetAnomalyAnalysisQuery,
  useGetEmployeeVehiclePerformanceQuery,
  useGetWasteAmountsByRegionQuery,
  useGetRouteAssignmentAnalysisQuery,
  useGetScheduleMutation,
  useSendFeedbackMutation,
} = aiApi
